import * as swcHelpers from '@swc/helpers';
import '../utils/get-payment-status-label.js';
import { getPrices } from '../utils/get-prices.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import { mapBundleChildLineItems } from '../utils/map-bundle-child-line-items.js';
import { toBaseLineItem } from './base-line-item.js';

const toNonPrescriptionBundleOrderLineItem = (lineItem, intl, options = {})=>{
    const { originalPrice , discountPrice  } = getPrices(lineItem);
    const { productPrice , totalPaid  } = lineItem.product;
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'NON_PRESCRIPTION_BUNDLE',
        // originalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        originalPrice: originalPrice || 0,
        // lineItemDiscountedPrice is the price with the discount applied which we show next to the TOTAL PRICE for the entire bundle, including child line items
        discountPrice,
        // productOriginalPrice is the non-discounted price we show as the price of the main bundle line item, i.e. the main product of the line item
        productOriginalPrice: productPrice,
        // productDiscountedPrice is the discounted price we show as the price of the main bundle line item, i.e. the main product of the line item
        productDiscountedPrice: totalPaid === productPrice ? undefined : productPrice,
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toNonPrescriptionBundleOrderLineItem };
//# sourceMappingURL=non-prescription-bundle-line-item.js.map
